import DapDSCodePuncher from './code-puncher.component'

export * from './code-puncher.component'
export default DapDSCodePuncher

DapDSCodePuncher.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-code-puncher': DapDSCodePuncher
  }
}
